












import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { FollowingStatistic } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { LikeSubjectType } from "@scrile/api-provider/dist/api/LikeProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useContentFeed from "@/hooks/useContentFeed";
import providers from "@/lib/api";
import config from "@/config";
import ProfileStatisticView from "../ProfileStatisticView";

export default defineComponent({
  name: "ProfileStatistic",
  components: { ProfileStatisticView },
  props: {
    userId: {
      type: String,
      required: true,
    },
    isAuthor: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object as () => UserPublicData,
      required: true,
    },
  },
  setup(props) {
    const { isAdmin } = useAuthUser();
    const { contentFeedStatsGetCount } = useContentFeed();
    const followingStatistic = ref<FollowingStatistic | null>(null);
    const postsStatistic = ref(0);
    const likesStatistic = ref(0);
    const showFollowers = computed(() => props.isAuthor || config.featurePublicFollowers || isAdmin.value);
    const showFollowing = computed(() => props.isAuthor || config.featurePublicFollowing || isAdmin.value);
    const showLikes = computed(() => config.featureProfileLikeStats && checkRole(props.user.role, "creator"));
    const hidePostsStats = computed(() => !config.featureEveryoneCanPost && checkRole(props.user.role, "member"));

    const getData = async (userId: string) => {
      if (showFollowers.value || showFollowing.value) {
        const response = await providers.FollowingsProvider.getStatistic({ ids: [userId] });
        followingStatistic.value = response[0] ?? null;
      }
      if (showLikes.value) {
        const response = await providers.LikeProvider.getStatsByOwners({
          data: { ownerIds: [userId], subjectType: LikeSubjectType.CONTENT_SET },
        });
        likesStatistic.value = response[userId] ?? 0;
      }
      if (!hidePostsStats.value) {
        postsStatistic.value = (await contentFeedStatsGetCount(userId, "media")) ?? 0;
      }
    };
    watch(
      toRef(props, "userId"),
      async userId => {
        await getData(userId);
      },
      { immediate: true }
    );
    return {
      showLikes,
      showFollowers,
      showFollowing,
      postsStatistic,
      likesStatistic,
      followingStatistic,
      hidePostsStats,
    };
  },
});
